module.exports = __webpack_public_path__ + "img/GT.DeepFoundation.DrivenPile.SteelDrivenPileSingle250mm.aa02a3a4.png";